import React from "react";
import Trend from "../Garments/Trend";

export default function TrendPage() {
  return <Trend />;
}
